<template>
    <div id="optTime" class="opt_g" :class="{opt_open: this.openedLayer === 'time'}" @click.stop="openLayer">
        <div class="opt_selected">
						<span class="tf_opt">
							<span class="txt_selected" id="optTimeSelected">{{ timeText[time] }}</span>
							<span class="txt_desc" id="optTimeDesc">{{ timeDesc }}</span>
							<span class="ico_cafetop ico_arrow">옵션 더 보기</span>
						</span>
        </div>
        <div id="optTime_layer" class="opt_layer" v-show="openedLayer === 'time'">
            <ul class="list_opt"  @click.stop="setTime">
                <li id="optTime_hourly" :class="{ on: time === 'hourly' }">실시간</li>
                <li id="optTime_daily" :class="{ on: time === 'daily' }">일간</li>
                <li id="optTime_weekly" v-if="tab === 'cheer'" :class="{ on: time === 'weekly' }">주간</li>
                <li id="optTime_annually" :class="{ on: time === 'annually' }">연간</li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
      date: {
          type: Number,
          default: 10000000
      }  
    },
    data() {
        return {
            timeText: {
                hourly: "실시간",
                daily: "일간",
                weekly: "주간",
                annually: "연간"
            }
        }
    },
    computed: {
        ...mapState(["tab", "time", "openedLayer"]),
        timeDesc() {
            const time = new Date(this.date);
            time.setDate(time.getDate() - 1);

            switch (this.time) {
                case "hourly":
                    return time.getHours() + "시";
                case "daily":
                    return time.getMonth() + 1 + "월 " + time.getDate() + "일";
                case "weekly":
                    return this.getWeekOfMonth();
                case "annually":
                    return time.getFullYear() + "년";
            }
        }
    },
    methods: {
        openLayer() {
            this.$store.commit("setOpenedLayer", "time");
        },
        closeLayer() {
            this.$store.commit("setOpenedLayer", "");
        },
        setTime(e) {
            const time = e.target.id.replace("optTime_", "");
            this.$store.commit("setTime", time);

            this.$emit('reset-rank-num');

            this.closeLayer();
        },
        getWeekOfMonth() {
            const date = new Date();
            date.setDate(date.getDate() - 7); // 일주일 전
            const lastThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate() + (4 - date.getDay())); //목요일
            const firstOfMonth = new Date(lastThursday.getFullYear(), lastThursday.getMonth(), 1); //이번달 첫날
            const weekNo = this.getWeekNumber(lastThursday) - this.getWeekNumber(firstOfMonth) + 1;
            return (lastThursday.getMonth() + 1) + "월 " + weekNo + "주";
        },
        getWeekNumber(d) {
            d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            d.setDate(d.getDate() + 4 - (d.getDay() || 7));
            const yearStart = new Date(Date.UTC(d.getFullYear(), 0, 1));
            return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
        },
    }
}
</script>
